import { Button } from '@finn-auto/design-system/atoms/button';
import { RefreshCw } from 'lucide-react';
import finnLogo from '../assets/finn-logo.png';

/**
 * Candidate-facing fallback for the public booking route — shown instead of a
 * blank page if the booking view throws. Deliberately generic and reassuring:
 * the candidate is external, so it names no recruiter and asks them to reload or
 * reply to the invite email. A reload usually clears a transient crash (e.g. the
 * browser's auto-translate mutating the DOM).
 */
export function BookingErrorFallback({ onReload }: { onReload: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-snow px-4">
      <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center">
        <img src={finnLogo} alt="FINN" className="mx-auto mb-6 h-8" />
        <h1 className="text-lg font-semibold text-gray-900">This page didn’t load</h1>
        <p className="mt-2 text-sm text-gray-600">
          Something went wrong opening your interview booking. Please reload — if it keeps happening,
          just reply to the email that brought you here and we’ll sort it out.
        </p>
        <Button className="mt-5" onClick={onReload}>
          <RefreshCw className="mr-1.5 h-4 w-4" /> Reload
        </Button>
        <p className="mt-4 text-xs text-gray-400">
          Tip: if your browser is translating this page, turning translation off can help.
        </p>
      </div>
    </div>
  );
}
